/*
 * $Id:: model.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all, call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';

import { base64ToBlobPdf } from '../../common/utils/service';
import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME, IMAGE_SLICE_NAME } from './constants';
import { fetchApplicationsPaginated, fetchApplicationReceipt, fetchApplicationsExport, fetchImage } from './service';

function* requestMyApplications(action) {
    const me = yield select(meSlice);
    const { userId, parentUserId } = me || {};
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchApplicationsPaginated, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: { message: response.error.description, extraInfo: response.error.extraInfo },
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* getMyApplications() {
    yield takeLatest(`${SLICE_NAME}/requestMyApplications`, requestMyApplications);
}

function* requestApplicationReceipt(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchApplicationReceipt, {
        ...action.payload,
    });
    if (!response.error) {
        if (!!response.receipt) {
            const file = base64ToBlobPdf(response.receipt);
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
        }
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
}

function* getApplicationReceipt() {
    yield takeLatest(`${SLICE_NAME}/requestApplicationReceipt`, requestApplicationReceipt);
}

function* requestMyApplicationsExport(action) {
    const { type, applicationType } = action.payload.params;
    if (type && (type === 'excel' || type === 'pdf')) {
        yield all([
            put({
                type: `${SLICE_NAME}/exportLoading`,
                payload: `applications.${applicationType !== 'patents' ? applicationType + 's' : applicationType}.${type}.export.loading.text`,
            }),
            put({ type: `${SLICE_NAME}/error`, payload: false }),
        ]);
        const response = yield call(fetchApplicationsExport, {
            ...action.payload,
        });
        if (!response.error) {
            const filename = response.headers.get('Content-Disposition').split('filename=')[1].replace(/"/g, '');
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            });
        } else {
            yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
        }
    }
    yield put({ type: `${SLICE_NAME}/exportLoading`, payload: false });
}

function* getMyApplicationsExport() {
    yield takeLatest(`${SLICE_NAME}/requestMyApplicationsExport`, requestMyApplicationsExport);
}

function* requestImage(action) {
    const imageID = action.payload.params.requestBody.imageId;
    const me = yield select(meSlice);
    const { userId, parentUserId } = me || {};
    yield all([
        put({ type: `${IMAGE_SLICE_NAME}/loading`, payload: { loadingImages: { [imageID]: true } } }),
        put({ type: `${IMAGE_SLICE_NAME}/error`, payload: { errorImages: { [imageID]: false } } }),
    ]);
    const response = yield call(fetchImage, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({ type: `${IMAGE_SLICE_NAME}/list`, payload: { images: { [imageID]: response } } });
    } else {
        yield put({
            type: `${IMAGE_SLICE_NAME}/error`,
            payload: { errorImages: { [imageID]: true } },
        });
    }
    yield put({ type: `${IMAGE_SLICE_NAME}/loading`, payload: { loadingImages: { [imageID]: false } } });
}

function* getImage() {
    yield takeEvery(`${IMAGE_SLICE_NAME}/requestImage`, requestImage);
}

export { getMyApplications, getApplicationReceipt, getMyApplicationsExport, getImage };
